import React, { useContext, useEffect, useState } from "react";
import { Filters } from "react-table";
import { AuthContext } from "../Auth/AuthProvider";
import { ProfileContext } from "../Auth/ProfileProvider";
import Resident from "../Residents/Models/Resident";
import { abpnClient } from "../Services/AbpnClient";
import { PostGraduateYear } from "../Training/Models/PostGraduateYear";

interface IAlumniRosterProviderValue {
    roster: Array<Resident>,
    filteredRoster: Array<Resident>,
    filters: Filters<object>,
    isRosterLoading: boolean,
    updateFilteredRoster: (filteredResidents: Array<Resident>) => void,
    updateFilters: (filters: Filters<object>) => void
}

export const AlumniRosterContext = React.createContext<IAlumniRosterProviderValue>(null);

export const AlumniRosterProvider = ({ children }: { children: JSX.Element }) => {
    const [roster, setRoster] = useState<Array<Resident>>(null);
    const [filteredRoster, setFilteredRoster] = useState<Array<Resident>>(null);
    const [filters, setFilters] = useState<Filters<object>>([]);
    const [isRosterLoading, setIsRosterLoading] = useState<boolean>(false);
    const { user } = useContext(ProfileContext);
    const authContext = useContext(AuthContext);

    const updateFilters = (filters: Filters<object>) => {
        setFilters(filters);
    }

    const updateFilteredRoster = (filteredResidents: Array<Resident>) => {
        setFilteredRoster(filteredResidents);
    }

    const sortLastName = (a: Resident, b: Resident) => {
        return a.name?.lastName > b.name?.lastName ? 1 : -1;
    }

    useEffect(() => {
        const getProgramLastPgyAttended = (years: Array<PostGraduateYear>) => {
            let programYears = years.filter(_ => _.trainingProgramId === user.selectedTrainingProgramId);
            let sortedYears = programYears.sort((a, b) => new Date(a.endDate).getTime() - new Date(b.endDate).getTime());

            return sortedYears[sortedYears.length - 1];
        }

        const sortPgyDesc = (a: Resident, b: Resident) => {
            let aLastProgramPgy = getProgramLastPgyAttended(a.postGraduateYears);
            let aPgyEndDateYear = new Date(aLastProgramPgy.endDate).getFullYear();
            let bLastProgramPgy = getProgramLastPgyAttended(b.postGraduateYears);
            let bPgyEndDateYear = new Date(bLastProgramPgy.endDate).getFullYear();

            return aPgyEndDateYear > bPgyEndDateYear ? -1 : 1;
        }

        const loadRoster = async () => {
            setIsRosterLoading(true);
            let userProgramTypeId = user.trainingPrograms.find(
                (_) => _.trainingProgramId === user.selectedTrainingProgramId
              ).trainingProgramTypeId;
            let url = `/api/dashboard/GetAllResidents?programTypeId=${userProgramTypeId}`;
            let rosterResult = await abpnClient.get<Array<Resident>>(url, authContext);
            let sortedResult = rosterResult
                .filter(_ => _.currentTrainingProgramId !== user.selectedTrainingProgramId)
                .sort(sortLastName)
                .sort(sortPgyDesc);
            setRoster(sortedResult);
            setFilteredRoster(sortedResult);
            setIsRosterLoading(false);
        };

        loadRoster();
    }, [authContext, user.selectedTrainingProgramId])

    return <AlumniRosterContext.Provider value={{ roster, filteredRoster, filters, isRosterLoading, updateFilteredRoster, updateFilters }}> {children}</ AlumniRosterContext.Provider>;
}